import { Types } from "../actions/ShiftPlansActions";

const initialState = {
    shiftPlans: {},
    isTaskUpdated: false,
};

export const ShiftPlansReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_SHIFTPLANS:
            return {
                ...state,
                shiftPlans: action.payload ?? state.shiftPlans,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
